/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ContractorMutation
 */
export interface ContractorMutation {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ContractorMutation
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ContractorMutation
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorMutation
     */
    hasLogin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorMutation
     */
    restored: boolean;
}

/**
 * Check if a given object implements the ContractorMutation interface.
 */
export function instanceOfContractorMutation(value: object): value is ContractorMutation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('hasLogin' in value) || value['hasLogin'] === undefined) return false;
    if (!('restored' in value) || value['restored'] === undefined) return false;
    return true;
}

export function ContractorMutationFromJSON(json: any): ContractorMutation {
    return ContractorMutationFromJSONTyped(json, false);
}

export function ContractorMutationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractorMutation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'hasLogin': json['hasLogin'],
        'restored': json['restored'],
    };
}

export function ContractorMutationToJSON(json: any): ContractorMutation {
    return ContractorMutationToJSONTyped(json, false);
}

export function ContractorMutationToJSONTyped(value?: ContractorMutation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'hasLogin': value['hasLogin'],
        'restored': value['restored'],
    };
}

